/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Theme/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Primary from './Primary/index'
import PrimaryDark from './PrimaryDark/index'
import PrimaryLight from './PrimaryLight/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Theme({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/Theme",
  onChange
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let settingsThemeValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'theme',
format: fromHelpers.selectDefault,
})
let settingsThemeChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'theme',
})
let settingsThemeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'theme',
})
let constantData = 'custom'
let aggregateData = fromAggregate.equals(settingsThemeValueData1, constantData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="options"
 from={optionsValueData}
 data="settings.theme"
 format="helpers.js selectDefault"
 value={settingsThemeValueData}
 onChange={settingsThemeChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Theme"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
<fromFlow.When is={aggregateData}>
<div
  data-testid="Theme.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Theme.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-5OQKg': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Primary
  viewPath={`${viewPath}/Primary`}
/>
<PrimaryDark
  viewPath={`${viewPath}/PrimaryDark`}
/>
<PrimaryLight
  viewPath={`${viewPath}/PrimaryLight`}
/>
</div>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}